import calls from '@/backend/api-calls'

const state = () => ({
  estimation: null,
  estimationSummary: null,
  firstLoad: true,
  loading: false,
  summaryFirstLoad: true,
  summaryLoading: false
})

// getters
const getters = {
  ids: state => {
    return state.estimation.estimation_details.map(d => d.id);
  }
}

// actions
const actions = {
  getEstimation: ({commit}, id) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.estimation.get(id)
        .then(resp => {
          commit("setEstimation", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  updateEstimation: ({commit}, { estimationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.estimation.put(estimationId, data)
        .then(resp => {
          commit("setEstimation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Estimaton successfully updated'
          }, { root: true });
          
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addDetail: ({commit}, detail) => {
    return new Promise((resolve, reject) => {
      calls.estimationDetails.post(detail).then(
        resp => {
          commit("insertEstimationDetail", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Estimation detail successfully added'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateDetail: ({commit}, { detailId, data }) => {
    return new Promise((resolve, reject) => {
      calls.estimationDetail.put(detailId, data).then(
        resp => {
          commit("insertUpdatedDetail", resp.data);
          // commit("app/setNotification", {
          //   type: 'success',
          //   status: true,
          //   message: 'Estimation detail successfully updated'
          // }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteDetail: ({commit}, detailId) => {
    return new Promise((resolve, reject) => {
      calls.estimationDetail.delete(detailId).then(
        resp => {
          commit("removeDetail", detailId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Estimation detail successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  getEstimationSummary: ({commit}, id) => {
    commit("setSummaryLoading", true);

    return new Promise((resolve, reject) => {
      calls.estimationSummary.get(id)
        .then(resp => {
          commit("setEstimationSummary", resp.data);
          commit("setSummaryLoading", false);
          commit("setSummaryFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setSummaryLoading", false);
          reject(err);
        })
    })
  },
  adjustSummaryPrice: ({commit}, { estimationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.estimationSummary.post(estimationId, data)
        .then(resp => {
          commit("setEstimationSummary", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setEstimation(state, data) {
    state.estimation = data;
  },
  setSummaryFirstLoad(state, status) {
    state.summaryFirstLoad = status;
  },
  setSummaryLoading(state, status) {
    state.summaryLoading = status;
  },
  setEstimationSummary(state, data) {
    state.estimationSummary = data;
  },
  insertEstimationDetail(state, detail) {
    state.estimation.estimation_details.push(detail);
  },
  insertUpdatedDetail(state, detail) {
    state.estimation.estimation_details.forEach((estimationDetail, i) => {
      if (estimationDetail.id == detail.id) {
        state.estimation.estimation_details.splice(i, 1, detail);
      }
    })
  },
  removeDetail(state, detailId) {
    state.estimation.estimation_details.forEach((estimationDetail, i) => {
      if (estimationDetail.id == detailId) {
        state.estimation.estimation_details.splice(i, 1);
      }
    });
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}